// import IETBHEC26_Template from '../assets/IETBHEC26_PaperSubmission_Template.doc'
import S0 from '../assets/images/San Jose State University.jpg'
import S3 from '../assets/images/Logo_HCM-UTE.png'
// import Arun from '../assets/images/vice_chancellor_img.jpg'
// import Alex from '../assets/images/Alex Stojcevski.jpg'
import CurtinLogo from '../assets/images/Curtin Singapore logo - keyline.jpg'
import APAQA from '../assets/images/APAQA_Logo.png'

function CallForPapers() {
    return (
        <div>
            <h2>Call for Papers</h2>
            <p>
                The IETBHEC’27 Committee invites your participation and seeks scholarly paper proposals to identify, reflect on, or respond to, trends, innovations and developments that relate to engineering, technology, business and health education and its stakeholders. We expect papers to offer conference participants a fresh or novel perspective and therefore contain original contributions and can be theoretical, experimental or application-focused, or unique reports of experience. Contribution can be theoretical, experimental, or application based.
            </p>
            <p><strong>IETBHEC’27 CONFERENCE TOPICS ARE (NOT LIMITED TO):</strong></p>
            <strong>Pedagogy and Curriculum Development </strong>
            <ul id='home-highlights'>
                <li>Innovative teaching methodologies & instructional design </li>
                <li>Interactive learning strategies: flipped, blended, online</li>
                <li>Project and Problem-based learning </li>
                <li>Enhancing student diversity and student experience in learning</li>
            </ul>
            <br></br>
            <strong>Trends & Emerging Influences</strong>
            <ul id='home-highlights'>
                <li>Impact of new technologies (GenAI, Chat GPT, etc) on higher education</li>
                <li>Social, environmental and policy challenges </li>
                <li>Sustainability and its role in education </li>
                <li>Social media and interdisciplinary research paradigms</li>
            </ul>
            <br></br>
            <strong>Academic Administration & Management</strong>
            <ul id='home-highlights'>
                <li>Institutional governance and quality management </li>
                <li>International collaborations and transnational education </li>
                <li>Assessment design, challenges and innovations </li>
                <li>Faculty development & pedagogy training </li>
            </ul>
            <br></br>
            <strong>Language & Communication in Education</strong>
            <ul id='home-highlights'>
                <li>English proficiency and workplace readiness </li>
                <li>Effective communication: teaching and assurance of learning </li>
                <li>Digital & non-verbal communication strategies </li>
            </ul>
            <br></br>
            <strong>Special Topics</strong>
            <ul id='home-highlights'>
                <li>Work Integrated Learning (WIL) and employability</li>
                <li>Entrepreneurship education and innovation </li>
                <li>Human-computer Interaction (HCI) applications for educational purposes</li>
                <li>Lifelong learning and continuous professional development </li>
            </ul>
            <br></br>
            <p>Submit your full paper now at: <a href="https://edas.info/N34444">edas.info</a></p>
            {/* <p>Paper Template: <a href={IETBHEC26_Template} target='_blank' rel="noreferrer noopener">IETBHEC26_PaperSubmission_Template.doc</a></p> */}
            <strong>Conference Publications</strong>
            <p>All accepted and presented papers will appear in the indexed proceedings (post conference) published by the conference committee. The proceedings of the conference will be Scopus indexed and published through a reputed publisher (World Scientific, Singapore). </p>
            <p>In addition, all papers presented at the conference will be considered by the award committee for the Best Paper Awards. The awarded papers and other selected papers will be invited to be published in the special issues of International Journals as announced on the Conference Website.</p>
            <p>All papers must be presented by the author(s) personally to be published in the conference proceedings.</p>

            <section className="sponsor-strip">
                <h4>Proudly supported by</h4>

                <div className="sponsor-strip-logos">
                    <img src={S0} alt="" />
                    <img src={S3} alt="" />
                    <img src={CurtinLogo} alt="" />
                    <img src={APAQA} alt="" />
                </div>
            </section>
        </div>
    )
}

export default CallForPapers